import { render, staticRenderFns } from "./MeShareCollection.vue?vue&type=template&id=5d508193&scoped=true"
import script from "./MeShareCollection.vue?vue&type=script&lang=js"
export * from "./MeShareCollection.vue?vue&type=script&lang=js"
import style0 from "./MeShareCollection.vue?vue&type=style&index=0&id=5d508193&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d508193",
  null
  
)

export default component.exports